var _style, _path, _path2, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _path3, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTandlaege(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Tandlaege",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.2;fill:none;stroke:#777775;stroke-width:2.8426;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#777775;stroke-width:2.8426;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.3,58.7c-1.7,2-2.7,4.5-3.2,7.1c-0.6,3-1.4,6.8-1.9,9.4c-0.2,0.9-0.7,1.7-1.3,2.2c-0.7,0.5-1.5,0.9-2.4,0.9 c-1.8,0-3.3-1.2-3.7-2.9l-1.6-6.7c-0.6-2.3-3.9-2.3-4.5,0l-1.6,6.7c-0.2,0.9-0.7,1.6-1.3,2.1c-0.7,0.5-1.5,0.8-2.4,0.8 c-1.8,0-3.4-1.3-3.7-3.1c-0.5-2.6-1.3-6.4-1.9-9.4c-0.5-2.6-1.6-5-3.2-7.1c-1.8-2.2-2.9-5.1-2.6-8.3c0.5-5.5,4.9-9.9,10.4-10.4 c1.7-0.1,3.3,0.1,4.7,0.6c2.6,0.9,5.3,0.9,7.9,0c1.5-0.5,3.1-0.7,4.7-0.6c2.9,0.3,5.6,1.6,7.4,3.7c-0.3,0.5-0.6,0.9-1,1.3 c-1.1,1.1-2.6,1.7-4.2,1.7c3.3,0,5.9,2.7,5.9,5.9c0-1.6,0.7-3.1,1.7-4.2c0,0,0.1-0.1,0.1-0.1c0.2,0.6,0.3,1.3,0.4,2 C74.2,53.6,73.2,56.5,71.3,58.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.2,43.8c0,0-3.8,2.3-8.4,2.3s-8.4-2.3-8.4-2.3"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 24.4,
    y1: 40.7,
    x2: 27.1,
    y2: 40.7
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 78.5,
    y1: 52.7,
    x2: 81.2,
    y2: 52.7
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 54.8,
    y1: 26.3,
    x2: 54.8,
    y2: 29.1
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 27.9,
    y1: 53.9,
    x2: 30.3,
    y2: 52.6
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 75.3,
    y1: 40.9,
    x2: 77.7,
    y2: 39.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 37.6,
    y1: 17.9,
    x2: 39,
    y2: 20.2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 66.7,
    y1: 32.2,
    x2: 68,
    y2: 29.9
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 27.9,
    y1: 27.5,
    x2: 30.3,
    y2: 28.9
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 75.3,
    y1: 64.6,
    x2: 77.7,
    y2: 65.9
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 24.4,
    y1: 40.7,
    x2: 27.1,
    y2: 40.7
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 78.5,
    y1: 52.7,
    x2: 81.2,
    y2: 52.7
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 54.8,
    y1: 26.3,
    x2: 54.8,
    y2: 29.1
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 27.9,
    y1: 53.9,
    x2: 30.3,
    y2: 52.6
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 75.3,
    y1: 40.9,
    x2: 77.7,
    y2: 39.5
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 37.6,
    y1: 17.9,
    x2: 39,
    y2: 20.2
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 66.7,
    y1: 32.2,
    x2: 68,
    y2: 29.9
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 27.9,
    y1: 27.5,
    x2: 30.3,
    y2: 28.9
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 75.3,
    y1: 64.6,
    x2: 77.7,
    y2: 65.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.6,46.8c-1.6,0-3,0.6-4.1,1.6v0c0,0-0.1,0.1-0.1,0.1c-1.1,1.1-1.7,2.6-1.7,4.2c0-3.3-2.7-5.9-5.9-5.9 c1.6,0,3.1-0.7,4.2-1.7c0.4-0.4,0.7-0.8,1-1.3c0.5-0.8,0.7-1.8,0.7-2.9c0,1.6,0.7,3.1,1.7,4.2C74.5,46.2,76,46.8,77.6,46.8z"
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 25.3,
    y1: 39.8,
    x2: 28,
    y2: 39.8
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 79.4,
    y1: 51.8,
    x2: 82.1,
    y2: 51.8
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 55.7,
    y1: 25.4,
    x2: 55.7,
    y2: 28.1
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 28.9,
    y1: 53,
    x2: 31.2,
    y2: 51.7
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 76.2,
    y1: 40,
    x2: 78.6,
    y2: 38.6
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 38.5,
    y1: 17,
    x2: 39.9,
    y2: 19.3
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 67.6,
    y1: 31.3,
    x2: 68.9,
    y2: 29
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 28.9,
    y1: 26.6,
    x2: 31.2,
    y2: 28
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 76.2,
    y1: 63.7,
    x2: 78.6,
    y2: 65
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M64.1,42.9c0,0-3.8,2.3-8.4,2.3s-8.4-2.3-8.4-2.3"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M72.2,57.8c-1.7,2-2.7,4.5-3.2,7.1c-0.6,3-1.4,6.8-1.9,9.4c-0.2,0.9-0.7,1.7-1.3,2.2 c-0.7,0.5-1.5,0.9-2.4,0.9c-1.8,0-3.3-1.2-3.7-2.9L58,67.7c-0.6-2.3-3.9-2.3-4.5,0l-1.6,6.7c-0.2,0.9-0.7,1.6-1.3,2.1 c-0.7,0.5-1.5,0.8-2.4,0.8c-1.8,0-3.4-1.3-3.7-3.1c-0.5-2.6-1.3-6.4-1.9-9.4c-0.5-2.6-1.6-5-3.2-7.1c-1.8-2.2-2.9-5.1-2.6-8.3 c0.5-5.5,4.9-9.9,10.4-10.4c1.7-0.1,3.3,0.1,4.7,0.6c2.6,0.9,5.3,0.9,7.9,0c1.5-0.5,3.1-0.7,4.7-0.6c2.9,0.3,5.6,1.6,7.4,3.7 c-0.3,0.5-0.6,0.9-1,1.3c-1.1,1.1-2.6,1.7-4.2,1.7c3.3,0,5.9,2.7,5.9,5.9c0-1.6,0.7-3.1,1.7-4.2c0,0,0.1-0.1,0.1-0.1 c0.2,0.6,0.3,1.3,0.4,2C75.1,52.7,74.1,55.6,72.2,57.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 38.5,
    y1: 17,
    x2: 39.9,
    y2: 19.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 28.9,
    y1: 26.6,
    x2: 31.2,
    y2: 28
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 25.3,
    y1: 39.8,
    x2: 28,
    y2: 39.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 28.9,
    y1: 53,
    x2: 31.2,
    y2: 51.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 79.4,
    y1: 51.8,
    x2: 82.1,
    y2: 51.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 76.2,
    y1: 40,
    x2: 78.6,
    y2: 38.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 55.7,
    y1: 25.4,
    x2: 55.7,
    y2: 28.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 67.6,
    y1: 31.3,
    x2: 68.9,
    y2: 29
  })))), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 76.2,
    y1: 63.7,
    x2: 78.6,
    y2: 65
  })))))), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M78.5,45.9c-1.6,0-3,0.6-4.1,1.6v0c0,0-0.1,0.1-0.1,0.1c-1.1,1.1-1.7,2.6-1.7,4.2c0-3.3-2.7-5.9-5.9-5.9 c1.6,0,3.1-0.7,4.2-1.7c0.4-0.4,0.7-0.8,1-1.3c0.5-0.8,0.7-1.8,0.7-2.9c0,1.6,0.7,3.1,1.7,4.2C75.4,45.2,76.9,45.9,78.5,45.9z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTandlaege);
export default __webpack_public_path__ + "static/media/Tandlaege.41e405d4d7acaf7173ed258cb07d0c8b.svg";
export { ForwardRef as ReactComponent };